// Фабрика платформ.
// Переменная VITE_PLATFORM ('web' | 'yandex') задаётся при сборке.

import type { Platform } from './types';

export type { Platform, PlayerInfo } from './types';

export async function createPlatform(): Promise<Platform> {
  const target = (import.meta as any).env?.VITE_PLATFORM ?? 'web';

  if (target === 'yandex') {
    const { YandexPlatform } = await import('./YandexPlatform');
    const p = new YandexPlatform();
    await p.init();
    return p;
  }

  // По умолчанию — web3
  const { WebPlatform } = await import('./WebPlatform');
  const p = new WebPlatform();
  await p.init();
  return p;
}
